import React from "react";

export default function SlayersSoul() {
  return (
    <>
      <p class="c2">
        <span>
          <p>
            Luc rode high through the Mountains of Dhoom, His heart was bold,
            but he met his doom. Isam waited where shadows creep, A hunter born
            in darkness deep.
          </p>
          <p>
            The Shadow calls, the hunt begins, Two souls bound in deadly sins.
          </p>
          <p>
            One did die, one did live, Twisted fate will not forgive. Both are
            bound, both are cursed, The hounds now run, the blood will burst.
            Slayer walks, a shadow’s thirst.
          </p>
          <p>
            Isam grew where the Myrddraal play, A boy who learned to kill each
            day. Luc was noble, a prince of light, Now they walk as one in the
            night.
          </p>
          <p>
            One did die, one did live, Twisted fate will not forgive. Both are
            bound, both are cursed, The hounds now run, the blood will burst.
            Slayer walks, a shadow’s thirst.
          </p>
          <p>
            The hunt begins with the Shadow’s hound, Luc and Isam, forever
            bound. They prowl the world, they stalk the dream, A fractured soul
            with a silent scream.
          </p>
          <p>
            The Town was dark, no child should stay, Yet Isam survived in the
            shadow’s sway. Luc’s honor lost, his soul betrayed, Together they
            kill where shadows play.
          </p>
          <p>
            In darkness bound, their fates entwine, A shattered soul, a cursed
            design. The hunt goes on, the shadow’s art, Two lives as one, yet
            worlds apart.
          </p>
        </span>
      </p>
    </>
  );
}
